import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { NavMenu } from "../../components/NavMenu";

export const Layout = ({ access, children }) => {
  const location = useLocation();
  const pathname = location.pathname.split("/")[1];

  return (
    <>
      <NavMenu pathname={pathname} access={access} />
      {children}
      <ToastContainer theme="colored" style={{ whiteSpace: "pre-line" }} />
    </>
  );
};

Layout.propTypes = {
  access: PropTypes.object,
  children: PropTypes.element.isRequired,
};
